var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.23684,
    cy: 7.23684,
    r: 7.23684,
    fill: "#D7EED5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2417 4.11916C10.5982 4.47565 10.5982 5.05364 10.2417 5.41014L5.48836 10.1635C5.13187 10.52 4.55388 10.52 4.19738 10.1635C3.84089 9.807 3.84089 9.22901 4.19738 8.87251L8.95074 4.11916C9.30723 3.76266 9.88522 3.76267 10.2417 4.11916Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1636 10.1631C9.80706 10.5196 9.22907 10.5196 8.87258 10.1631L4.11922 5.40975C3.76273 5.05325 3.76273 4.47526 4.11922 4.11877C4.47572 3.76228 5.05371 3.76228 5.4102 4.11877L10.1636 8.87213C10.52 9.22862 10.52 9.80661 10.1636 10.1631Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalClose);
export default __webpack_public_path__ + "static/media/modal-close.3c0f126d52bd47710ffc5398aba97841.svg";
export { ForwardRef as ReactComponent };